import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanPurposeUpdateModalUI from './LoanPurposeUpdateModalUI.js'

class LoanPurposeUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      purpose: this.props.loan.purpose || '',
      purposeError: null,
    }
  }

  render() {
    return (
      <LoanPurposeUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        disbursementDate={this.state.disbursementDate}
        onDisbursementDateChange={(selectedDateISO) => {
          this.setState({ disbursementDate: selectedDateISO })
        }}
        purpose={this.state.purpose}
        onPurposeChange={(event) => { this.setState({ purpose: event.target.value }) }}
        purposeError={this.state.purposeError}
        setPurposeError={(error) => { this.setState({ purposeError: error }) }}
        loanPurposeList={this.state.loanPurposeList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSectors(context)
    Modal.setAppElement('body')
  }

  getSectors(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/references`,
      cacheKey: CacheKeys.Sectors(),
      callback: this.getSectorsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getSectorsCallback = (response) => {
    let loanPurposeList = response.sectorList.map((sectors) => {
      return { key: sectors.name, value: sectors.label };
    });
    this.setState({ errorList: response.errorList, loanPurposeList: loanPurposeList })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/purpose`,
      this.onSubmitCallback, {
      purpose: this.state.purpose,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 1000)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default LoanPurposeUpdateModalSF
